import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import csTranslation from './translations/cs.json';
import enTranslation from './translations/en.json';
import ukTranslation from './translations/uk.json';
import zhCnTranslation from './translations/zh-cn.json';
import deTranslation from './translations/de.json';
import huTranslation from './translations/hu.json';
import esTranslation from './translations/es.json';
import frTranslation from './translations/fr.json';
import itTranslation from './translations/it.json';

const messages = {
  cs: csTranslation,
  en: enTranslation,
  uk: ukTranslation,
  "zh-cn": zhCnTranslation,
  de: deTranslation,
  hu: huTranslation,
  es: esTranslation,
  fr: frTranslation,
  it: itTranslation
};

export const i18n = new VueI18n({
  locale: 'en',
  messages,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
});